import {InputSelectAccesses} from '@/features/medical-reports/components/input-select-accesses/InputSelectAccesses'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'
import {EventTypeKeyName} from '@/features/agenda/types'

const AccessesToRecoveryFieldSchema = AgendaEventFieldsSchema.pick({
    missedAccess: true
})
type AccessesToRecoveryFieldSchema = z.infer<typeof AccessesToRecoveryFieldSchema>

interface AccessesToRecoveryFieldProps {
    patientId: string
    accessType: EventTypeKeyName
}

export const AccessesToRecoveryField = ({patientId, accessType}: AccessesToRecoveryFieldProps) => {
    const {t} = useTranslation()
    const {control} = useFormContext<AccessesToRecoveryFieldSchema>()

    const {
        field: missedAccessField,
        fieldState: {error: missedAccessError}
    } = useController({
        control,
        name: 'missedAccess'
    })

    return (
        <InputSelectAccesses
            label={t('agenda:access_to_recover_label')}
            mode="single"
            value={missedAccessField.value}
            onChange={missedAccessField.onChange}
            errorMessage={missedAccessError?.message}
            queryParams={{
                patient: patientId,
                accessType,
                type: 'absence'
            }}
        />
    )
}
